import React from 'react';
import { Modal, Button } from 'react-bootstrap'

class ModalAlert extends React.Component {
	onClose = null;

	constructor(props) {
		super(props);
		this.state = { visible: false }
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	open = (message, onClose) => {
		this.setState({ visible: true, message: message }, function () {
			this.onClose = onClose;
		});
	}

	close = () => {
		this.setState({ visible: false }, function () {
			if (this.onClose !== null && this.onClose !== undefined)
				this.onClose();

			this.onClose = null;
		});
	}

	render() {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.close} dialogClassName="modal-45w">
					<Modal.Body>
						<div dangerouslySetInnerHTML={{ __html: this.state.message }} />
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.close}>Close</Button>
					</Modal.Footer>
				</Modal>
			</React.Fragment>)
	}
}

export default ModalAlert;



// WEBPACK FOOTER //
// ./src/fw/modals/alert/Alert.js